import React, { useState } from "react";
import { getBrowserData } from "../../../utils/helpers";
import { useEffect } from "react";
import Button from "../../../components/button";
import { useTranslation, Trans } from "react-i18next";

export default function CacheStep({ startLoaderOndemand ,onCancelQuestions }) {
    const { t } = useTranslation("clientOnDemand");
    const [error, setError] = useState(false);

    const [check4, setCheck4] = useState(false);
    const [check5, setCheck5] = useState(false);
    const [check6, setCheck6] = useState(false);
    const [checkYes, setCheckYes] = useState(false);
    // const [checkNo, setCheckNo] = useState(false);

    const changeHandler = (e, setCheck, type) => {
        setCheck(e.target.checked)
        if (e.target.checked) {
            setCheckYes(e.target.value);
            // setCheckYesMain(e.target.value);
        } else {
            setCheckYes('');
            ;
            // setCheckYesMain(e.target.checked)
        }
    };

    const onClickHandler2 = () => {
        if (
            checkYes === "yes"
        ) {
            // setStep(1);
            setError(false);

            startLoaderOndemand('step2');
        } else {
            setError(true);
        }

    };
    return (
        <div class="container-fluid question-container">
            {/* {console.log(ua,"ua")} */}
            <div class="row justify-content-center">
                <div class="col-11 col-sm-10 col-md-10 col-lg-8 col-xl-8 text-center p-0 mt-3 mb-2">
                    <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
                        <form id="msform">
                            <fieldset>
                                <div class="form-card">
                                    <h3 className="d-block text-center font-size-28">  {t("cache.title")}</h3>
                                    <h3 className="d-block font-size-20">
                                        {t("cache.intro")}
                                        <br />
                                    </h3>
                                    <h3 className="d-block font-size-20">  {t("cache.okayOccasionally")}</h3>
                                    <ul>
                                        <li>
                                            <h3 className="d-block font-size-20">
                                                {t("cache.improves")}
                                            </h3>
                                        </li>
                                        <li>

                                            <h3 className="d-block font-size-20">
                                                {t("cache.fixes")}
                                            </h3>
                                        </li>
                                        <li>
                                            <h3 className="d-block font-size-20">
                                                {t("cache.clean")}
                                            </h3>
                                        </li>
                                        <li>
                                            <h3 className="d-block font-size-20">
                                                {t("cache.hygiene")}
                                            </h3>
                                        </li>
                                    </ul>
                                    <h3 className="d-block font-size-20">
                                        <Trans i18nKey="cache.whatIsCache" ns="clientOnDemand" t={t} />
                                    </h3>
                                    <br />
                                    <br />
                                    <ul>
                                        <li>
                                            <h3 className="font-size-20 text-left d-block ">
                                                {" "}
                                                {t("cache.mac")}
                                            </h3>
                                        </li>
                                        <li>
                                            <h3 className="font-size-20 text-left d-block">
                                                {" "}
                                                {t("cache.windows")}
                                            </h3>
                                            <ol type="a" className="font-size-20 line-height-30px">
                                                <li>
                                                    {t("cache.chrome")}
                                                    <ol type="i">
                                                        <li>{t("cache.chromeSteps.dots")}
                                                        </li>
                                                        <li>{t("cache.chromeSteps.scrollHistory")}</li>
                                                        <li>{t("cache.chromeSteps.leftHistory")}</li>
                                                        <li>{t("cache.chromeSteps.deleteBrowsing")}</li>
                                                        <li> {t("cache.chromeSteps.timeRange")}</li>
                                                        <li>{t("cache.chromeSteps.cacheSelected")}</li>
                                                        <li>{t("cache.chromeSteps.deleteData")}</li>

                                                    </ol>
                                                </li>
                                            </ol>
                                        </li>
                                        <li>
                                            <h3 className="font-size-20 text-left d-block">
                                                {" "}
                                                <Trans i18nKey="cache.safari" ns="clientOnDemand" t={t} />
                                            </h3>
                                        </li>
                                    </ul>

                                    <br />


                                </div>
                                <div class="form-card">
                                    <div class="row wrap">

                                        <div class="new secend-step">
                                            <div class="form-group">
                                                <input
                                                    onChange={(e) => {
                                                        changeHandler(e, setCheckYes, "radio");
                                                    }}
                                                    value={"yes"}
                                                    checked={checkYes === "yes" ? "checked" : ''}
                                                    name="yesNo"
                                                    type="checkbox"
                                                    id="yes"
                                                />
                                                <label htmlFor="yes">{t("cache.confirmCleared")}</label>
                                                {error && (
                                                    <div className="mt-2">
                                                        <p className="red ml-5">
                                                            {t("cache.selectCheckbox")}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">


                                    <Button
                                        status={0}
                                        onClick={onCancelQuestions}
                                        type="button"
                                        className={ `height-56 resend-btn width-175-px previous action-button-previous`}
                                        title={t("actions.cancel")}
                                    />
                                    <Button
                                        status={0}
                                        onClick={onClickHandler2}
                                        type="button"
                                        className={` height-56 resend-btn width-175-px next action-button"`}
                                        title={t("actions.next")}
                                    />
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
